class Nomenclature {
  constructor({ id, name, quantity, previousItems = [], nextItems = [] }) {
    this.id = id;
    this.name = name;
    this.quantity = quantity;
    this.previousItems = previousItems;
    this.nextItems = nextItems;
  }
}

class OperationBlock {
  constructor({ id, name, time, incomingNomenclature = [], outgoingNomenclature = [], additionalInfo = [], previousOperations, nextOperations, finalOperationId, finalNomenclatureId }) {
    this.id = id;
    this.name = name;
    this.time = time;
    this.additionalInfo = additionalInfo;
    this.incomingNomenclature = incomingNomenclature.map(n => new Nomenclature({ id: n.nomenclature_id, name: n.nomenclature_name, quantity: n.quantity, previousItems: n.previous_items, nextItems: n.next_items }));
    this.outgoingNomenclature = outgoingNomenclature.map(n => new Nomenclature({ id: n.nomenclature_id, name: n.nomenclature_name, quantity: n.quantity, previousItems: n.previous_items, nextItems: n.next_items }));
    this.previousOperations = previousOperations;
    this.nextOperations = nextOperations;
    this.finalOperationId = finalOperationId;
    this.finalNomenclatureId = finalNomenclatureId;
  }
}

class TKModel {
  constructor() {
    this.operationBlocks = [];
  }

  addOperationBlock(operationBlock) {
    this.operationBlocks.push(operationBlock);
  }

  removeOperationBlock(blockId) {
    const index = this.operationBlocks.findIndex(block => block.id === blockId);
    if (index !== -1) {
      this.operationBlocks.splice(index, 1);
    }
  }

  getFinalNomenclatures() {
    const finalNomenclatures = [];
    this.operationBlocks.forEach(block => {
      block.outgoingNomenclature.forEach(output => {
        if (this.operationBlocks.every(b => b.incomingNomenclature.every(input => input.id !== output.id))) {
          finalNomenclatures.push(output);
        }
      });
    });
    return finalNomenclatures;
  }

  getFinalOperation() {
    return this.operationBlocks.find(op => op.finalOperationId === op.id)
  }

  getOperations() {
    let index = 1;
    const finalOperation = this.getFinalOperation();

    const revertedOperations = [];

    const pushCurrentOperation = (currentOperation, index) => {
      revertedOperations.push(currentOperation);
      if (currentOperation.previousOperations.length) {
        currentOperation.previousOperations.forEach(prevOperationId => {
          if (!revertedOperations.some(({ id }) => prevOperationId === id)) {
            const prevOperation = this.operationBlocks.find(({ id }) => id === prevOperationId);
            pushCurrentOperation(prevOperation);
          }
        });
      }
    }

    if (finalOperation) {
      pushCurrentOperation(finalOperation, index);
    }

    return revertedOperations;
  }

  match(currOperId, operations, currSteps, targetOperId) {
    if (currOperId === targetOperId) {
      return currSteps;
    }

    let maxSteps = -1;
    const tempOper = operations.find(op => op.id === currOperId);
    const tempPrevOper = tempOper.previousOperations;

    for (let e = 0; e < tempPrevOper.length; e++) {
      const prevOperId = tempPrevOper[e];
      const steps = this.match(prevOperId, operations, currSteps + 1, targetOperId);

      if (steps > maxSteps) {
        maxSteps = steps;
      }
    }

    return maxSteps;
  }



  addXPositionToOperation(operations, finalOperation) {
    const operationsWithXCoordinate = [];

    const operationsQuantity = operations.length;
    const finalOperationNumber = operations.findIndex(op => op.id === finalOperation.id);

    for (let i = 0; i < operationsQuantity; i++) {
      let currStep = 0;

      if (i !== finalOperationNumber) {
        let targetOper = operations[i];
        let targetOperId = targetOper.id;
        operationsWithXCoordinate[i] = { operation: operations[i], xIndex: this.match(finalOperation.id, operations, currStep, targetOperId) };
      } else {
        operationsWithXCoordinate[i] = { operation: operations[i], xIndex: finalOperationNumber };
      }
    }

    const groupedOperationsArray = [];

    operationsWithXCoordinate.forEach(item => {
      const { xIndex, operation } = item;
      if (!groupedOperationsArray[xIndex]) {
        groupedOperationsArray[xIndex] = [];
      }
      groupedOperationsArray[xIndex].push({ ...operation, xIndex });
    });

    const filteredGroupedOperationsArray = groupedOperationsArray.filter(group => group !== undefined);

    return filteredGroupedOperationsArray;
  }


  checkIsNomWaste(nomID) {
    const operations = this.getOperations();

    for (let i = 0; i < operations.length; i++) {
      const operation = operations[i];
      const noms = operation.incomingNomenclature;

      for (let e = 0; e < noms.length; e++) {
        const nom = noms[e];
        const nomName = nom.id;

        if (nomID === nomName) {
          return false;
        }
      }
    }
    return true;
  }

  checkIsFirstTimeNom(nomID) {
    const operations = this.getOperations();

    for (let i = 0; i < operations.length; i++) {
      const operation = operations[i];
      const noms = operation.outgoingNomenclature;

      for (let e = 0; e < noms.length; e++) {
        const nom = noms[e];
        const nomName = nom.id;

        if (nomID === nomName) {
          return false;
        }
      }
    }

    return true;
  }

  markHeightInOutgoingNomenclatures(operations) {
    operations.forEach((currentOperationLine, i) => {
      currentOperationLine.forEach(currentOperation => {
        currentOperation.outgoingNomenclature.forEach((outN, outNIndex) => {
          const isWasteNomenclature = this.checkIsNomWaste(outN.id);

          outN.yIndex = outNIndex;
          outN.isWasteNomenclature = isWasteNomenclature;
        })
      })
    })
  }

  markHeightIncomingNomenclatures(operations) {
    operations.forEach((currentOperationLine, i) => {
      currentOperationLine.forEach(currentOperation => {
        currentOperation.incomingNomenclature.forEach((incomingN, outNIndex) => {
          const isFirstTimeNomenclature = this.checkIsFirstTimeNom(incomingN.id);

          incomingN.yIndex = outNIndex;
          incomingN.isFirstTimeNomenclature = isFirstTimeNomenclature;
        })
      })
    })
  }

  markHeightInOperations(operations) {
    operations.forEach((currentOperationLine) => {
      currentOperationLine.forEach((currentOperation, operationIndex) => {
        const maxNomenclaturesHeight = currentOperation.incomingNomenclature.length > currentOperation.outgoingNomenclature.length ?
          currentOperation.incomingNomenclature.length
          : currentOperation.outgoingNomenclature.length;

        currentOperation.yIndex = (operationIndex);
      });
    })
  }

  isFinalNomenclature(id) {
    return this.getFinalNomenclatures().some(n => n.id === id);
  }

  isStockNomenclature(id) {
    return this.operationBlocks.some(block => block.incomingNomenclature.some(n => n.id === id) && block.outgoingNomenclature.every(n => n.id !== id));
  }

  isExtraProductNomenclature(id) {
    return this.operationBlocks.some(block => block.outgoingNomenclature.some(n => n.id === id) && block.incomingNomenclature.every(n => n.id !== id));
  }

  getNomenclatureById(id) {
    for (const block of this.operationBlocks) {
      const foundInIncoming = block.incomingNomenclature.find(n => n.id === id);
      if (foundInIncoming) return foundInIncoming;

      const foundInOutgoing = block.outgoingNomenclature.find(n => n.id === id);
      if (foundInOutgoing) return foundInOutgoing;
    }
    return null;
  }

  isNomenclatureInNextOperations(id) {
    for (const block of this.operationBlocks) {
      if (block.incomingNomenclature.some(n => n.id === id)) {
        return true;
      }
    }
    return false;
  }
}

export { Nomenclature, OperationBlock, TKModel };